import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatCard } from '@angular/material/card';


@Component({
    selector: 'app-more-errors',
    template: `
    @for (error of data; track error) {
      <mat-card
        appearance="outlined"
        class="card"
        style="background-color: #323232; color: #b9b9b9; margin-bottom: 10px; font-family: TimesNewRoman"
        >
        {{ error.payload.data.error.message }}
      </mat-card>
    }
    <button mat-raised-button (click)="closeClicked()" color="primary" style="float: right;">
      Close
    </button>
    `,
    styleUrls: [],
    imports: [
    MatCard,
    MatButton
]
})
export class MoreErrorsComponent {
  dialogRef = inject<MatDialogRef<MoreErrorsComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);


  closeClicked() {
    this.dialogRef.close();
  }
}
